import { MediaConstraints } from "./types";

export enum HISTORY_ACTIONS {
  POP = "POP",
  PUSH = "PUSH",
  REPLACE = "REPLACE",
}

export enum LOCAL_STORAGE_NAMES {
  LIVE_CHAT_NAME = "liveChatName",
  MEDIA_CONSTRAINTS = "mediaConstraints",
}

export enum SendDataEvent {
  PRODUCER_FINISHED_STREAM = "PRODUCER_FINISHED_STREAM",
}

export const defaultMediaConstraints: MediaConstraints = {
  video: true,
  audio: true,
  videoEnabled: false,
  audioEnabled: false,
  shareEnabled: false,
  blurEnabled: false,
};
